import axios from 'axios'
import { showToast } from '@nutui/nutui';
import { getToken } from '@/utils/auth'
import { apiUrl } from './constant';
// create an axios instance
const service = axios.create({
  baseURL: apiUrl, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 100000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    config.headers['token'] = getToken()
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response
    // if the custom code is not 20000, it is judged as an error.
    if (res.status !== 200) {
      
      showToast.fail('Access-token 失效')

      if (res.status === 403) {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      }
      return Promise.reject(new Error('Error'))
    } else {
      const { data } = res

      if (data.code !== 0) {
        
        showToast.fail(data.msg || 'Error')

        return Promise.reject(new Error(data.msg || 'Error'))
      }

      return data
    }
  },
  error => {

    showToast.fail(error.message)
    return Promise.reject(error)
  }
)

export default service
